import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MonthCard = ({ month, isExpanded, onToggle, onViewContent }) => {
  const getMonthColor = (monthName) => {
    const colors = {
      'January': 'bg-[#F5F7FA]/5 border-[#F5F7FA]/30',
      'February': 'bg-pink-50 border-pink-200',
      'March': 'bg-green-50 border-green-200',
      'April': 'bg-yellow-50 border-yellow-200',
      'May': 'bg-purple-50 border-purple-200',
      'June': 'bg-indigo-50 border-indigo-200',
      'July': 'bg-red-50 border-red-200',
      'August': 'bg-orange-50 border-orange-200',
      'September': 'bg-teal-50 border-teal-200',
      'October': 'bg-amber-50 border-amber-200',
      'November': 'bg-cyan-50 border-cyan-200',
      'December': 'bg-emerald-50 border-emerald-200'
    };
    return colors?.[monthName] || 'bg-gray-50 border-gray-200';
  };

  return (
    <div className={`border rounded-lg overflow-hidden transition-all duration-250 ${getMonthColor(month?.name)}`}>
      <button
        onClick={onToggle}
        className="w-full p-4 md:p-6 flex items-center justify-between hover:bg-white/50 transition-all duration-250"
        aria-expanded={isExpanded}
        aria-label={`Toggle ${month?.name} calendar details`}
      >
        <div className="flex items-center gap-3 md:gap-4">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-lg bg-white shadow-sm flex items-center justify-center">
            <Icon name="Calendar" size={24} color="var(--color-primary)" />
          </div>
          <div className="text-left">
            <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">{month?.name}</h3>
            <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">{month?.theme}</p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={24} 
          className="text-muted-foreground transition-transform duration-250"
        />
      </button>
      {isExpanded && (
        <div className="p-4 md:p-6 bg-white border-t border-border">
          <div className="mb-4 md:mb-6">
            <h4 className="text-sm md:text-base font-medium text-foreground mb-2">Monthly Theme</h4>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{month?.description}</p>
          </div>

          <div className="space-y-3 md:space-y-4">
            <h4 className="text-sm md:text-base font-medium text-foreground">Weekly Post Ideas</h4>
            {month?.weeklyPosts?.map((post, index) => (
              <div 
                key={index}
                className="p-3 md:p-4 bg-muted/50 rounded-lg border border-border transition-all duration-250"
                style={{ '--hover-border-color': 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.5)))' }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.5)))'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = ''}
              >
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xs md:text-sm font-medium text-primary">Week {index + 1}</span>
                    <span className="px-2 py-1 text-xs rounded bg-primary text-primary-foreground">
                      {post?.format}
                    </span>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onViewContent(post?.contentId)}
                    iconName="ExternalLink"
                    iconPosition="right"
                    className="text-xs"
                  >
                    View
                  </Button>
                </div>
                <p className="text-sm md:text-base text-foreground font-medium mb-1">{post?.title}</p>
                <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">{post?.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthCard;